import { ClassNames, DayPicker, DateRange } from "react-day-picker";
import styled from "styled-components";
import { useState, useRef, useEffect } from "react";
import CloseIcon from "../icon/closeIcon";
import CustomButton from "../common/customButton";
import { ko } from "date-fns/locale";
import { addDays } from "date-fns";
const Wrapper = styled.div`
  /* position: fixed;
  top: 36%;
  left: 41%; */
  top: 30vw;
  left: 35vw;
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 9999;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: space-between;
`;
const ModalWrapper = styled.div`
  /* width: 84%;
  height: 100%; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 35vw;
  height: 45vw;
  margin-left: 1vw;
  /* outline: 1px solid red; */
  background-color: white;
  border-radius: 2vw;
  box-shadow: 0 0.5vh 0.5vh rgba(0, 0, 0, 0.08),
    0 0.5vh 0.5vh rgba(0, 0, 0, 0.006);
`;

const ModalTopArea = styled.div`
  margin-top: 1vw;
  width: 100%;
  height: 5vw;
  display: flex;
  justify-content: end;
  align-items: center;
`;

const DateWrapper = styled.div`
  width: 100%;
  height: 37vw;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
`;
const Title = styled.div`
  width: 80%;
  color: #989898;
  font-size: 2.4vw;
  font-weight: 700;
  margin-top: 2vw;
  height: 4vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const CloseBtnBox = styled.div`
  width: 3vw;
  height: 3vw;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1vw;
  background-color: #8080802f;
`;

const BtnBox = styled.div`
  margin-top: 1vw;
  margin-bottom: 3vw;
  width: 77%;
  display: flex;
  justify-content: space-between;
  /* outline: 1px solid red; */
`;
const SubTitle = styled.div`
  color: #989898;
  font-size: 1.5vw;
  width: 80%;
  font-weight: 500;
  margin-top: 1vw;
`;
const ReactDayPick = styled(DayPicker)`
  * {
    --rdp-cell-size: 4vw;
    --rdp-caption-font-size: 3vw;
    --rdp-accent-color: #ff7f3b;
    --rdp-background-color: #ff7f3b;
    /* Switch to dark colors for dark themes */
    --rdp-accent-color-dark: #ff7f3b;
    --rdp-background-color-dark: #ff7f3b;
    /* Outline border for focused elements */
    --rdp-outline: 0.2vw solid var(--rdp-accent-color);
    /* Outline border for focused and selected elements */
    --rdp-outline-selected: 0.2vw solid #dbdbdb;
  }
  /* 조정되는 부분 */
  .rdp-caption {
    font-size: 2vw; /* 월 폰트 크기 */
  }

  .rdp-head_cell {
    font-size: 2vw; /* 요일 폰트 크기 */
  }

  .rdp-day {
    font-size: 2vw; /* 날짜 폰트 크기 */
  }

  /* 선택된 날짜 스타일 조정 */
  .rdp-day_selected {
    background-color: #ff7f3b;
    color: white;
    font-size: 2vw;
  }
`;
const DateFilterListModal = (props: any) => {
  const {
    onClose,
    deleteValue,
    // value,
    // setValue,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    dateType,
    setOnDateVisible,
    btnDateClose,
  } = props;

  // 날짜 문자열에서 `Date` 객체로 변환
  const getDateFromValue = (value: string): Date => {
    const year = parseInt(value.slice(0, 4), 10);
    const month = parseInt(value.slice(4, 6), 10) - 1; // 월은 0부터 시작
    const day = parseInt(value.slice(6, 8), 10);
    return new Date(year, month, day);
  };

  const initiallyStartSelectedDates = getDateFromValue(startDate);
  const initiallyEndSelectedDates = getDateFromValue(endDate);
  const [startSelectedDate, setStartSelectedDate] = useState<Date | undefined>(
    initiallyStartSelectedDates
  );
  const [endSelectedDate, setEndSelectedDate] = useState<Date | undefined>(
    initiallyEndSelectedDates
  );
  const divRef = useRef<any>(null);
  const [dimensions, setDimensions] = useState<any>({
    width: 0,
    height: 0,
  });

  //   `startDate`가 변경될 때마다 `selectedDay` 업데이트
  useEffect(() => {
    setStartSelectedDate(getDateFromValue(startDate));
  }, [startDate]);

  //   `endDate`가 변경될 때마다 `selectedDay` 업데이트
  useEffect(() => {
    setEndSelectedDate(getDateFromValue(endDate));
  }, [endDate]);

  const startHandleComplete = (date: any) => {
    if (date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 월은 0부터 시작하므로 1을 더합니다.
      const day = date.getDate().toString().padStart(2, "0");

      // 3. "YYYYMMDD" 형식으로 변환
      const formattedDate = `${year}${month}${day}`;
      // if (formattedDate !== value) {
      //   setValue(formattedDate);
      setStartSelectedDate(date);
      setStartDate(formattedDate);

      // }
    }
  };
  const deleteData = (type: any) => {
    if (type === "START") {
      setStartSelectedDate(getDateFromValue("00000000"));
      setStartDate("");
    } else {
      setEndSelectedDate(getDateFromValue("00000000"));
      setEndDate("");
    }
  };
  const closeBtn = () => {
    setStartSelectedDate(getDateFromValue("00000000"));
    setStartDate("");
    setEndSelectedDate(getDateFromValue("00000000"));
    setEndDate("");
    setOnDateVisible(false);
  };
  const endHandleComplete = (date: any) => {
    if (date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 월은 0부터 시작하므로 1을 더합니다.
      const day = date.getDate().toString().padStart(2, "0");

      // 3. "YYYYMMDD" 형식으로 변환
      const formattedDate = `${year}${month}${day}`;
      // if (formattedDate !== value) {
      //   setValue(formattedDate);
      setEndSelectedDate(date);
      setEndDate(formattedDate);
    }
  };
  useEffect(() => {
    if (divRef.current?.offsetHeight && divRef.current?.offsetWidth) {
      setDimensions({
        width: divRef.current.offsetWidth,
        height: divRef.current.offsetHeight,
      });
    }
  }, []);
  return (
    <>
      <Wrapper ref={divRef} style={{ transform: "translate(1.2)" }}>
        <ModalWrapper>
          <DateWrapper>
            <Title>시작일</Title>
            <SubTitle>해당 검색은 접수일을 기준으로 합니다.</SubTitle>
            <ReactDayPick
              mode="single"
              styles={{
                caption: { color: "#ff7f3b" },
                head_cell: {
                  width: "100vw",
                },
              }}
              captionLayout="dropdown-buttons"
              defaultMonth={new Date()} // 시작 월
              fromMonth={new Date(2010, 0)} // 선택 가능한 시작 월
              toMonth={new Date()} // 선택 가능한 종료 월
              // defaultMonth={getDateFromValue(startDate)}
              // At least 2 dates must be selected
              modifiersStyles={{
                width: dimensions.width,
                day_selected: { color: "#ff7f3b" },
              }}
              selected={startSelectedDate}
              onSelect={startHandleComplete} // 선택 핸들러
              locale={ko}
            ></ReactDayPick>
          </DateWrapper>

          <BtnBox>
            <CustomButton
              width={"12vw"}
              height={"5vw"}
              text={`날짜 초기화`}
              size={"1.8vw"}
              radius={"0.4vw"}
              $bgColor={"#ffffff"}
              $border={"0.15vw solid #dcdcdc"}
              color={"#333333"}
              onClick={() => deleteData("START")}
            ></CustomButton>
          </BtnBox>
        </ModalWrapper>

        <ModalWrapper>
          <DateWrapper>
            <Title>
              종료일
              <CloseBtnBox>
                <CloseIcon onClick={closeBtn} height={"2vw"} fill={"#969696"} />
              </CloseBtnBox>
            </Title>
            <ModalTopArea></ModalTopArea>
            <ReactDayPick
              mode="single"
              styles={{
                caption: { color: "#ff7f3b" },
                head_cell: {
                  width: "100vw",
                },
              }}
              captionLayout="dropdown-buttons"
              // defaultMonth={getDateFromValue(endDate)}
              // At least 2 dates must be selected
              modifiersStyles={{
                width: dimensions.width,
                day_selected: { color: "#ff7f3b" },
              }}
              defaultMonth={new Date()} // 시작 월
              fromMonth={new Date(2010, 0)} // 선택 가능한 시작 월
              toMonth={new Date()} // 선택 가능한 종료 월
              selected={endSelectedDate}
              onSelect={endHandleComplete} // 선택 핸들러
              locale={ko}
            ></ReactDayPick>
          </DateWrapper>

          <BtnBox>
            <CustomButton
              width={"12vw"}
              height={"5vw"}
              text={`날짜 초기화`}
              size={"1.8vw"}
              radius={"0.4vw"}
              $bgColor={"#ffffff"}
              $border={"0.15vw solid #dcdcdc"}
              color={"#333333"}
              onClick={() => deleteData("END")}
            ></CustomButton>
            <CustomButton
              width={"12vw"}
              height={"5vw"}
              text={`확인`}
              size={"1.8vw"}
              radius={"0.4vw"}
              onClick={onClose}
            ></CustomButton>
          </BtnBox>
        </ModalWrapper>
      </Wrapper>
    </>
  );
};

export default DateFilterListModal;
